import { makeAutoObservable, toJS } from 'mobx';
import { UserRoleEnum } from '../enums/user-roles.enum';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { NavigateFunction } from 'react-router-dom';
import { BusinessApi } from 'shared/api';
import { LoadingStatusEnum } from 'shared/types';
import { businessStore } from 'entities/business/model/business-card.store';
import { LicenseEnum } from 'shared/types';

class UserStore {
  id = '';
  accountId = '';
  fio = '';
  email = '';
  phone = '';
  imgUrl = '';
  employeesCount = 0;
  licExpireDays = 0;
  licEmployeeLimit = 0;

  isLoadingDataStatus = LoadingStatusEnum.NOT_LOADING;
  role: UserRoleEnum = UserRoleEnum.USER;
  licType: LicenseEnum = LicenseEnum.BASE;

  constructor() {
    makeAutoObservable(this);
  }

  get AllData() {
    return toJS(this);
  }

  async init() {
    try {
      this.isLoadingDataStatus = LoadingStatusEnum.LOADING;
      const data = await BusinessApi.getAccountInfo();
      this.id = data.id;
      this.accountId = data.accountId ?? '';
      this.fio = data.fio;
      this.email = data.email;
      this.phone = data.phone;
      this.imgUrl = data.imgUrl;
      this.role = data.role;
      this.employeesCount = data.employeesCount;
      this.licExpireDays = data.licExpireDays;
      this.licEmployeeLimit = data.licEmployeeLimit;
      this.licType = data.licType;

      switch (data.role) {
        case UserRoleEnum.OWNER:
        case UserRoleEnum.ADMINISTRATOR:
        case UserRoleEnum.MANAGER:
        case UserRoleEnum.EMPLOYEE:
          if (data.businessId) {
            businessStore.businessId = data.businessId;
          }
          break;

        default:
          break;
      }
      this.isLoadingDataStatus = LoadingStatusEnum.SUCCESS;
    } catch (error) {
      this.isLoadingDataStatus = LoadingStatusEnum.ERROR;
    }
  }
  clear() {
    this.id = '';
    this.accountId = '';
    this.fio = '';
    this.email = '';
    this.phone = '';
    this.imgUrl = '';
    this.role = UserRoleEnum.USER;
    this.isLoadingDataStatus = LoadingStatusEnum.NOT_LOADING;
  }

  redirectToRoleBasedPage(navigate: NavigateFunction) {
    switch (this.role) {
      case UserRoleEnum.OWNER:
        navigate(AppLinks.BusinessesLink);
        break;
      case UserRoleEnum.ADMINISTRATOR:
        if (businessStore.businessId) {
          navigate(
            AppLinks.BusinessLink.replace(':id', businessStore.businessId)
          );
        } else {
          navigate(AppLinks.AboutLink);
        }

        break;
      case UserRoleEnum.MANAGER:
        if (businessStore.businessId) {
          navigate(
            AppLinks.BusinessLink.replace(':id', businessStore.businessId)
          );
        } else {
          navigate(AppLinks.AboutLink);
        }
        break;
      case UserRoleEnum.EMPLOYEE:
        if (businessStore.businessId) {
          navigate(
            AppLinks.BusinessLink.replace(':id', businessStore.businessId)
          );
        } else {
          navigate(AppLinks.AboutLink);
        }
        break;
      default:
        navigate(AppLinks.AboutLink);
        break;
    }
  }
}

export const userStore = new UserStore();
